import { css } from 'foundations-theming/utils';
export const getFocusStyleObject = ({
  theme,
  addBorderRadius,
  unwrapped,
  override
}) => {
  const styles = Object.assign({
    borderColor: 'transparent !important',
    outline: `${theme.borderWidth['200']} solid ${theme.color['border-info-default']} !important`,
    outlineOffset: `calc(${theme.borderWidth['200']} * -1)`,
    boxShadow: `inset 0 0 0 ${theme.borderWidth['200']} ${theme.color['border-core-on-fill-default']} !important`
  }, addBorderRadius && {
    borderRadius: theme.borderRadius['100']
  });
  if (override) {
    return {
      borderColor: 'inherit !important',
      boxShadow: 'none !important',
      outline: 'none !important'
    };
  }
  if (unwrapped) {
    return styles;
  }
  return {
    '&&:focus': styles
  };
};
export const getFocusStyle = ({
  theme,
  addBorderRadius,
  unwrapped,
  override
}) => css(getFocusStyleObject({
  theme,
  addBorderRadius,
  unwrapped,
  override
}));